import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux'
import { format, sub } from 'date-fns';

import { Button, Spinner, Tag, Modal, Animation } from 'components'
import { DeleteDialogue } from 'features';
import { FaCog, FaCheck, FaFileAlt, FaCircle } from 'react-icons/fa';

import * as api from 'api';
import * as actionCreators from 'store/actions';
import { userContext } from 'context';

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

const Placeholder = styled.div`
    width: 100%;
    font-size: 0.8rem;
    padding: 0.5rem;
    color: var(--secondary-accent-color);
    display: flex;
    align-items: center;
`

const TileContainer = styled.div`
    display: grid;
    grid-template-columns: min-content 1fr 7rem 4rem 5rem;
    grid-column-gap: 0rem;
    padding: 1rem;
    background-color: var(--secondary-color);
    box-shadow: var(--box-shadow);
    border-radius: 5px;
    cursor: pointer;
    align-items: center;
    margin: 0.5rem 0;
    :hover {
        filter: brightness(var(--brightness));
    }
`

const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1rem 0 0;
`

const Column = styled.div`
    display: grid;
    grid-template-rows: 1rem 0.9rem;
    align-items: center;
    overflow: hidden;
    padding: ${props => props.padding};
`

const Title = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const Label = styled.div`
    color: var(--secondary-accent-color);
    font-size: 0.8rem;
`

const StatusContainer = styled.div`
    display: grid;
    align-items: center;
    grid-template-columns: min-content auto;
    grid-column-gap: 0.5rem;
    padding: 0.3rem;
    height: 100%;
    border-radius: 5px;
    font-size: 0.8rem;
`

const InvoiceTile = props => {
    const {
        invoice
    } = props;
    const statusRef = {
        draft: {label: 'Draft', icon: <FaCircle/>},
        open: {label: 'Pending', icon: <FaCircle style={{color: 'var(--pending-color)'}}/>},
        paid: {label: 'Paid', icon: <FaCircle style={{color: 'var(--success-color)'}}/>},
        void: {label: 'Canceled', icon: <FaCircle style={{color: 'var(--error-color)'}}/>},
        uncollectible: {label: 'Canceled', icon: <FaCircle style={{color: 'var(--error-color)'}}/>}
    }

    return (
        <TileContainer onClick={() => window.open(invoice['link'])}>
            <Icon><FaFileAlt/></Icon>
            <Column padding='0 0.5rem 0 0'>
                <Title>{invoice['invoiceId']}</Title>
                <Label>Invoice</Label>
            </Column>

            <Column padding='0 0.5rem 0 0'>
                <Title>{format(new Date(invoice['created']*1000), 'd MMM yyyy')}</Title>
                <Label>Created</Label>
            </Column>

            <Column padding='0 0.5rem 0 0'>
                <Title>{invoice['total']}</Title>
                <Label>Amount</Label>
            </Column>

            <StatusContainer>
                {statusRef[invoice['status']]['icon']}
                {statusRef[invoice['status']]['label']}
                {/* {statusRef['void']['icon']}
                {statusRef['void']['label']} */}
            </StatusContainer>
        </TileContainer>
    )
}

const InvoiceSection = props => {
    const {

    } = props;
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)
    const invoices = useSelector((state) => state.payment.invoices)
    const [showSpinner, setSpinner] = React.useState(true)
    const spinner = <Spinner styles={{color:'var(--text-color)'}}/>

    React.useEffect(() => {
        if(user['subscription_plan'] !== userContext.PLANS.PREMIUM){
            setSpinner(false)
        } else if(!invoices){
            dispatch(actionCreators.getInvoices(user['uid']))
            setTimeout(() => {
                setSpinner(false)
            }, 2000)
        }
    }, [])

    const createBlocks = () => {
        let blocks = invoices ? invoices.map(invoice => (<InvoiceTile invoice={invoice}/>)) 
                    : [<Placeholder color='var(--secondary-accent-color)'>No invoices available</Placeholder>]
        // let blocks = [<div style={{color: 'var(--secondary-accent-color)', padding: '0 0 0 0.5rem'}}>No invoices available</div>]
        return blocks
    }

    if(!showSpinner || invoices){
        return (
            <Animation animation='expand'>
                <Container>
                    {createBlocks()}
                </Container>
            </Animation>
        )
    } else {
        return (
            <Container>
                <Placeholder>
                    <Spinner/>
                    <div style={{ marginLeft: '0.5rem' }}>Getting invoices</div>
                </Placeholder>
            </Container>
        )
    }
    
}

export default InvoiceSection;